import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { NftCard } from './NftCard';


export const Gallery = () => {
  const params = useParams();
  const [nfts, setNfts] = useState([]);

  useEffect(() => {
    // functions.httpsCallable('nfts')({ addresses: ['0x8fFC4FFC238F1BE9477A1d115D4c737e379ad226'] })
    //   .then(result => setNfts(result.data));
  }, []);

  return (
    <div>
      {nfts.map(nft => (
        <NftCard key={nft.id} moralisNft={nft} />
      ))}
    </div>
  )
};
